import { IApiError } from '@/models/apiError.model';
import {
  CancelledOrdersGroupBy,
  DatePresetKey,
  ICancelledOrdersData,
  ICancelledPartnerItem,
  ICancelledReasonItem,
  ICancelledOrdersQuery,
} from '@/models/cancelledOrders.model';
import { IPagination } from '@/models/pagination.model';
import { DEFAULT_DATE_PRESET } from '../helpers';

export const CANCELLED_ORDERS_SLICE_NAME = 'cancelledOrders';

export interface CancelledOrdersState {
  data: ICancelledOrdersData | null;
  reasonsList: ICancelledReasonItem[];
  partnersList: ICancelledPartnerItem[];
  reasonsMeta: IPagination | null;
  partnersMeta: IPagination | null;
  query: ICancelledOrdersQuery;
  preset: DatePresetKey;
  groupBy: CancelledOrdersGroupBy;
  isLoading: boolean;
  isListLoading: boolean;
  error: IApiError | null;
}

export const initialState: CancelledOrdersState = {
  data: null,
  reasonsList: [],
  partnersList: [],
  reasonsMeta: null,
  partnersMeta: null,
  query: { group_by: 'day' },
  preset: DEFAULT_DATE_PRESET,
  groupBy: 'day',
  isLoading: false,
  isListLoading: false,
  error: null,
};
